import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { PlpPreviewProduct } from 'src/services/plpPreview/types';
import type { ProductCarouselProduct } from 'src/types/Recommendations';

export const transformPlpPreviewProductToProductCarouselProduct = (
  product: PlpPreviewProduct,
  currencyCode: CurrencyCode,
): ProductCarouselProduct => {
  const preSalePrice = product.preSalePrices?.find((price) => price.currency === currencyCode);

  return {
    alt: product.title,
    freeDomesticDelivery: product.deliveryCost === 0,
    href: product.detailPageHref,
    isNew: product.isNew,
    isPurchasable: product.purchasable,
    onSale: product.onSale,
    preSalePrice: preSalePrice?.amount,
    price: product.price.amount,
    salePercentage: product.salePercentage ?? undefined,
    src: product.imageSrc,
    title: product.title,
  };
};
